import React, { memo } from 'react';
import styled from 'styled-components';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const Header = memo(
  ({
    title,
    isGoBack = true,
    options,
    className,
  }: {
    title: string;
    isGoBack?: boolean;
    options?: any;
    className?: string;
  }) => {
    const navigation = useNavigate();

    return (
      <Container className={className}>
        <div className="flex flex-row justify-between">
          <div
            className="flex flex-row items-center"
            onClick={() => {
              navigation(-1);
            }}
          >
            {isGoBack && <ArrowLeftOutlined />}
            {isGoBack && <div className="w-2" />}
            <label className="text-black">{title}</label>
          </div>
          {options}
        </div>
      </Container>
    );
  }
);

export const Container = styled.div`
  width: 100%;
  height: 30px;
  margin-bottom: 10px;

  label {
    font-size: 18px;
    font-weight: 600;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 10px;
  background-color: white;
`;

export { Header };
